import { unreachable } from '../utils/unreachable';

export enum State {
  Next = 2,
  Doing = 1,
  Done = 0,
  Pause = 4,
}

export function getStatusLabel(status: State): string {
  switch (status) {
    case State.Next:
      return 'Next';
    case State.Doing:
      return 'Doing';
    case State.Done:
      return 'Done';
    case State.Pause:
      return 'Pause';
    default:
      return unreachable(status);
  }
}
